/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';
import LogPropTypes from './PropTypes';
import LogContext from './Context';

class LogSubject {
    _setObservers(observers) {
        this._observers = observers || [];
    }

    trace(eventName, data) {
        this._observers.forEach((observer) => observer.trace(eventName, data));
    }

    debug(eventName, data) {
        this._observers.forEach((observer) => observer.debug(eventName, data));
    }

    info(eventName, data) {
        this._observers.forEach((observer) => observer.info(eventName, data));
    }

    warn(eventName, data) {
        this._observers.forEach((observer) => observer.warn(eventName, data));
    }

    error(eventName, data) {
        this._observers.forEach((observer) => observer.error(eventName, data));
    }

    fatal(eventName, data) {
        this._observers.forEach((observer) => observer.fatal(eventName, data));
    }
}

/**
 * This LogProvider serves as a subject within the observable pattern for
 * multiple log/loggers to attach to/subscribe to. Logs can be attached/detached
 * from the Subject by adding them to or removing them from the `observers`
 * property of this component.
 *
 * This allows us to delegate logging to multiple methods with the same request
 * to log information, such as EDAP logging and console logging.
 */
class LogSubjectProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: new LogSubject(),
        };
        this.state.subject._setObservers(props.observers);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        prevState.subject._setObservers(nextProps.observers);
        return prevState;
    }

    render() {
        return (
            <LogContext.Provider value={this.state.subject}>
                {this.props.children}
            </LogContext.Provider>
        );
    }
}

LogSubjectProvider.propTypes = {
    observers: PropTypes.arrayOf(PropTypes.shape(LogPropTypes)),
    children: PropTypes.node.isRequired,
};

export default LogSubjectProvider;
